import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Grid, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, Typography, useFormControl, Button, Tooltip, IconButton, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { lowerFirst } from 'lodash-es';
import { orange } from '@material-ui/core/colors';
import { useForm } from 'react-hook-form';
import { Send } from '@material-ui/icons';
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import Mensajes from './Mensajes';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  textAlign: {
    textAlign: 'center'
  },
  heidiv: {
    maxHeight: '140px'
  },
  messageRow: {
    // display: "flex"
    width: '90%'
  },
  messageRowRight: {
    display: "flex",
    justifyContent: "flex-end"
  },
  messageBlue: {
    position: "relative",
    marginLeft: "20px",
    marginBottom: "10px",
    padding: "17px",
    backgroundColor: "#A8DDFD",
    width: "80%",
    //height: "50px",
    textAlign: "left",
    font: "400 .85em 'Open Sans', sans-serif",
    border: "1px solid #97C6E3",
    borderRadius: "10px",
    "&:after": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "15px solid #A8DDFD",
      borderLeft: "15px solid transparent",
      borderRight: "15px solid transparent",
      top: "0",
      left: "-15px"
    },
    "&:before": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "17px solid #97C6E3",
      borderLeft: "16px solid transparent",
      borderRight: "16px solid transparent",
      top: "-1px",
      left: "-17px"
    }
  },
  messageOrange: {
    position: "relative",
    marginRight: "20px",
    marginBottom: "10px",
    padding: "17px",
    backgroundColor: "#f8e896",
    width: "80%",
    //height: "50px",
    textAlign: "left",
    font: "400 .85em 'Open Sans', sans-serif",
    border: "1px solid #dfd087",
    borderRadius: "10px",
    "&:after": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "15px solid #f8e896",
      borderLeft: "15px solid transparent",
      borderRight: "15px solid transparent",
      top: "0",
      right: "-15px"
    },
    "&:before": {
      content: "''",
      position: "absolute",
      width: "0",
      height: "0",
      borderTop: "17px solid #dfd087",
      borderLeft: "16px solid transparent",
      borderRight: "16px solid transparent",
      top: "-1px",
      right: "-17px"
    }
  },

  messageContent: {
    padding: 0,
    margin: 0
  },
  messageTimeStampRight: {
    position: "absolute",
    fontSize: ".85em",
    fontWeight: "300",
    marginTop: "10px",
    bottom: "-3px",
    right: "5px",
    padding: '4px'
  },

  orange: {
    color: theme.palette.getContrastText(orange[500]),
    backgroundColor: orange[500],
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  // avatarNothing: {
  //     color: "transparent",
  //     backgroundColor: "transparent",
  //     width: theme.spacing(4),
  //     height: theme.spacing(4)
  // },
  displayName: {
    marginLeft: "15px"
  },
  divConteiner: {
    maxHeight: '200px'
  }
}));

const Observaciones = ({ datoS, usuario, setCargando, id, tipoc = 'solicitud', pag = '' }) => {
  const classes = useStyles();
  const [arrDatos, setArrDatos] = useState(datoS);
  const [observacion, setObservacion] = useState(null);

  const guardarComentario = (data) => {
    serviciosSolicitudes.inserComentario(
      (respuesta) => { setArrDatos(respuesta.data.observaciones); setObservacion(''); },
      setCargando,
      { comentario: data, idsolicitud: id, tipo: tipoc, pag: pag }
    );
  };
  return (
    <div>
      {/* <Grid container spacing={3}>
       <Grid item xs={12}> */}
      {arrDatos && <div><Mensajes datoS={arrDatos} usuario={usuario} /> </div>}
      <div>
        {/* </Grid> */}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={10}>
              <TextField
                multiline
                id="outlined-error-helper-text"
                label="COMENTARIO"
                variant="outlined"
                fullWidth
                name="observacion"
                value={observacion}
                onChange={(e) => setObservacion(e.target.value)}
              />
            </Grid>
            <Grid item xs={2}>
              <Tooltip title="Enviar">
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={() => guardarComentario(observacion)}
                  disabled={observacion != null && observacion != '' ? false : true}
                >
                  <Send />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {/*</Grid> */}
    </div>
  );
};

export default Observaciones;